import { render, staticRenderFns } from "./SUpload.vue?vue&type=template&id=5a552c3e&"
import script from "./SUpload.vue?vue&type=script&lang=js&"
export * from "./SUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports